(function(window, document, $) {
	"use strict";
	$('iframe[src*="https://www.youtube.com/"]').each(function (){
		$(this).wrap('<div class="responsive-video-container"></div>');
	});
})(window, document, jQuery);